<!--
 Range Slider Component
 Shows available shop range sliders for given search input
 devs@droxit.de
 Copyright (c) 2022 droxIT GmbH
-->

<template>
  <b-container class="facet" fluid="md">
    <b-row class="rocketsearch-facet-row" align-v="center">
      <b-col cols=3 class="rocketsearch-facet-label">
        <span> {{ facet.label }} </span>
      </b-col>
      <b-col cols=9 class="rocketsearch-facet-content">
        <b-row class="rocketsearch-range-slider-info" align-h="between" align-v="center">
          <b-col cols=2 class="rocketsearch-range-slider-text-left">{{ sliderMin }} {{ tooltip }}</b-col>
          <b-col cols=8 class="rocketsearch-range-slider">
            <input v-on:change="setFilter()" type="range" v-bind:min="min" v-bind:max="max" step="1" v-model="sliderMin">
            <input v-on:change="setFilter()" type="range" v-bind:min="min" v-bind:max="max" step="1" v-model="sliderMax">
          </b-col>
          <b-col cols=2 class="rocketsearch-range-slider-text-left">{{ sliderMax }} {{ tooltip }}</b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
    name: 'RangeSliderMobile',
    props: {
      facet: Object,
      filter: Object
    },
    data() {
      var minS = Math.floor(this.facet.from);
      var maxS = Math.ceil(this.facet.to);
      if(this.filter){
        minS = this.filter.from || minS;
        maxS = this.filter.to || maxS;
      }
      return {
        min: Math.floor(this.facet.from),
        max: Math.ceil(this.facet.to),
        minSelected: minS,
        maxSelected: maxS,
        tooltip: this.facet.tooltip || ""
      }
    },
    computed: {
      sliderMin: {
        get: function() {
          var val = parseInt(this.minSelected);
          return val;
        },
        set: function(val) {
          val = parseInt(val);
          if (val > this.maxSelected) {
            this.maxSelected = val;
          }
          this.minSelected = val;
        }
      },
      sliderMax: {
        get: function() {
          var val = parseInt(this.maxSelected);
          return val;
        },
        set: function(val) {
          val = parseInt(val);
          if (val < this.minSelected) {
            this.minSelected = val;
          }
          this.maxSelected = val;
        }
      }
    },
    methods: {
      setFilter: function () {
        var selected = {};
        if (this.minSelected > this.min){
          selected["from"] = this.minSelected;
        }
        if (this.maxSelected < this.max){
          selected["to"] = this.maxSelected;
        }
        this.$root.$emit('RocketFilterSelectedEvent', { name: this.facet.name, options: selected });
      }
    }
}
</script>